import { render, staticRenderFns } from "./DialogAnnounceAllEmployee.vue?vue&type=template&id=4980ebc2&scoped=true&"
import script from "./DialogAnnounceAllEmployee.vue?vue&type=script&lang=js&"
export * from "./DialogAnnounceAllEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DialogAnnounceAllEmployee.vue?vue&type=style&index=0&id=4980ebc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980ebc2",
  null
  
)

export default component.exports